import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { OutputService } from '../../../infrastructure/services/output.service';
import { Location } from '@angular/common';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { OutputModel } from 'app/infrastructure/model/classes/output.classes';

@Component({
    selector: 'sx-configuration-output',
    templateUrl: './configuration.output.component.html',
})
export class ConfigurationOutputComponent implements OnInit {
    systemCode: string;
    outputCode: string;
    output: OutputModel;
    jobStatus:boolean;
    states = [
        { value: 0, description: 'None' },
        { value: 1, description: 'Quote' },
        { value: 2, description: 'Proposal' },
        { value: 3, description: 'Bindded' },
        { value: 4, description: 'Submission' },
    ];

    recurrences = [
        { value: 0, description: 'DAILY' },
        { value: 1, description: 'WEEKLY' },
        { value: 2, description: 'MONTHLY' },
    ];

    days = [
        { value: 0, description: 'SUNDAY' },
        { value: 1, description: 'MONDAY' },
        { value: 2, description: 'TUESDAY' },
        { value: 3, description: 'WEDNESDAY' },
        { value: 4, description: 'THURSDAY' },
        { value: 5, description: 'FRIDAY' },
        { value: 6, description: 'SATURDAY' }
    ];

    selectedDays = [];

    showDaily = false;
    showWeekly = false;
    showMonthly = false;

    selectedMonthRecurrencyType: number;

    daysOfMonth = Array(31).fill(1).map((item, index) => item + index);

    currentServerTime: Date;

    constructor(
        private aRoute: ActivatedRoute,
        private _router: Router,
        private outputService: OutputService,
        private location: Location,
        private alertService: AlertService,
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.outputCode = params['codoutput'];
            this.output = new OutputModel();
            this.outputService
                .get(this.systemCode, this.outputCode)
                .subscribe(data => {
                    if (!data) {
                        return this._router.navigateByUrl('/soc/404');
                    }

                    this.output = data;
                   
                    this.UpdateLocalTimeZone();
                    if (this.output.daysOfWeek !== null) {
                        this.selectedDays = JSON.parse(this.output.daysOfWeek);
                    }

                    this.setSelectedMonthRecurrencyType();

                    this.showRecurrenyConfiguration(this.output.recurrency);

                    /*if (this.output.startDate === null) {
                        this.output.startDate = new Date();
                    }*/
                });

            this.outputService.getCurrentServerTime().subscribe(time => {
                this.currentServerTime = time;
                this.updateServerTime();
            });
            
            this.outputService.getJobStatus(this.systemCode, this.outputCode)
            .subscribe(dataState => {
                this.jobStatus = dataState;
                });
        });
    }

    save() {
        let warningMessage = null;
        this.output.daysOfWeek = JSON.stringify(this.selectedDays);
        this.convertSelectedMonthRecurrencyType();

        if (!this.isValidDailyRecurrency()) {
            warningMessage = 'OUTPUT_DAILY_RECURRENCY_VALIDATION';
        }

        if (!this.isValidWeeklyRecurrency()) {
            warningMessage = 'OUTPUT_WEEKLY_RECURRENCY_VALIDATION';
        }

        if (!this.isValidMonthlyRecurrency()) {
            warningMessage = 'OUTPUT_MONTHLY_RECURRENCY_VALIDATION';
        }

        if (!this.isValidDelayTask()) {
            warningMessage = 'OUTPUT_DELAY_TASK_VALIDATION';
        }

        if (!this.isValidRepeatTask()) {
            warningMessage = 'OUTPUT_REPEAT_TASK_VALIDATION';
        }

        if (!this.isValidExpirationTask()) {
            warningMessage = 'OUTPUT_EXPIRATION_TASK_VALIDATION';
        }

        if (!this.isValidUTCExpirationDate()) {
            warningMessage = 'OUTPUT_EXPIRATION_LOWER';
        }

        if (warningMessage !== null) {
            return this.alertService.showGrowl({
                type: GrowlType.WARNING,
                body: warningMessage,
            });
        }

        this.output.timeZone = new Date(this.output.startDate).getTimezoneOffset();
        this.outputService.edit(this.output.outputCode, this.output.systemCode, this.output)
            .then(data => {
                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: 'EDITADO_CORRECTAMENTE',
                });
                this.outputService.getJobStatus(this.systemCode, this.outputCode)
                .subscribe(dataState => {
                this.jobStatus = dataState;
                });
            });
    }
    StopScheduler()
    {
        this.outputService.StopScheduler(this.output.outputCode, this.output.systemCode)
            .subscribe(data => {
                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: 'OUTPUT_STOP_SCHEDULER_SUCCESS',
                });
                this.jobStatus =false;
            });
    }
    onRecurrencyChange(recurrency) {
        this.output.recurrency = recurrency.value;
        this.showDaily = false;
        this.showWeekly = false;
        this.showMonthly = false;

        this.showRecurrenyConfiguration(recurrency.value);
    }

    onRecurrencyDayWeekChange(day) {
        const dayId = this.selectedDays.find(d => d === day.value);

        if (dayId !== undefined) {
            this.selectedDays = this.selectedDays.filter(d => d !== day.value);
        } else {
            this.selectedDays.push(day.value);
        }
        this.selectedDays.sort();
    }

    private showRecurrenyConfiguration(value) {
        switch (value) {
            case 0:
                this.showDaily = true;
                break;
            case 1:
                this.showWeekly = true;
                break;
            case 2:
                this.showMonthly = true;
                break;
        }
    }

    private convertSelectedMonthRecurrencyType() {
        this.output.recurrencyMonthDay = false;
        this.output.recurrencyFortnight = false;
        this.output.lastFriday = false;

        switch (this.selectedMonthRecurrencyType) {
            case 0:
                this.output.recurrencyMonthDay = true;
                break;
            case 1:
                this.output.recurrencyFortnight = true;
                break;
            case 2:
                this.output.lastFriday = true;
                break;
        }
    }

    private setSelectedMonthRecurrencyType() {
        if (this.output.recurrencyMonthDay) {
            this.selectedMonthRecurrencyType = 0;
        }

        if (this.output.recurrencyFortnight) {
            this.selectedMonthRecurrencyType = 1;
        }

        if (this.output.lastFriday) {
            this.selectedMonthRecurrencyType = 2;
        }
    }

    private isValidDailyRecurrency() {
        if (this.output.recurrency === 0) {
            return this.output.recurrencyDays ? true : false;
        }

        return true;
    }

    private isValidWeeklyRecurrency() {
        if (this.output.recurrency === 1) {
            return this.output.recurrencyWeek
                && this.selectedDays.length > 0;
        }

        return true;
    }

    private isValidMonthlyRecurrency() {
        if (this.output.recurrency === 2) {
            return (this.output.recurrencyMonthDay && this.output.monthDay)
                || this.output.lastFriday
                || this.output.recurrencyFortnight;
        }

        return true;
    }

    private isValidDelayTask() {
        if (this.output.delayTask) {
            return this.output.delayTaskHour ? true : false;
        }

        return true;
    }

    private isValidRepeatTask() {
        if (this.output.repeatTaskEver) {
            return this.output.repeatTaskHour ? true : false;
        }

        return true;
    }

    private isValidExpirationTask() {
        if (this.output.expireTask) {
            return this.output.expirationDate
                && this.output.expirationTime;
        }

        return true;
    }

    private updateServerTime() {
        if (this.currentServerTime) {
            setInterval(() => {
                const date = new Date(this.currentServerTime);
                date.setSeconds(date.getSeconds() + 1);
                this.currentServerTime = date;
            }, 1000);
        }
    }
    private isValidUTCExpirationDate(): boolean {
        const expirationTime = new Date( new Date(this.output.expirationDate + ' ' + this.output.expirationTime).getTime() - this.TimeZone());
        if(expirationTime > this.currentServerTime) {
            return true;
        }
        return false;
    }
    private UpdateLocalTimeZone() {

        if (this.TimeZone() !== 0) {
            const startDate = new Date(this.output.startDate + ' ' + this.output.startTime);
            const utcStartDate = startDate.getTime() - this.TimeZone();
            const localStarDate = new Date(utcStartDate);

            this.output.startDate = this.FormatDate(localStarDate);
            this.output.startTime = this.FormartTime(localStarDate);

            const expirationDate = new Date(this.output.expirationDate + ' ' + this.output.expirationTime);
            const utcExpirationDate = expirationDate.getTime() - this.TimeZone();
            const localExpirationDate = new Date(utcExpirationDate);
            this.output.expirationDate = this.FormatDate(localExpirationDate);
            this.output.expirationTime = this.FormartTime(localExpirationDate);
        }
    }
    private FormatDate(date: Date): string {
        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        const month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        return date.getFullYear() + '-' + month + '-' + day;
    }
    private FormartTime(date: Date): string {
        const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        return hours + ':' + minutes;
    }
    private TimeZone(): number {
        return (new Date()).getTimezoneOffset() * 60 * 1000;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/configuration/configuration.output.component.ts